class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    // Initialize cart note functionality
    this.initCartNote();
  }

  initCartNote() {
    // Wait for DOM to be ready
    document.addEventListener('DOMContentLoaded', () => {
      this.setupCartNoteListeners();
    });
    
    // Also setup immediately in case DOM is already loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        this.setupCartNoteListeners();
      });
    } else {
      this.setupCartNoteListeners();
    }
  }

  setupCartNoteListeners() {
    const checkbox = document.getElementById('cart-note-checkbox');
    const container = document.getElementById('cart-note-container');
    const input = document.getElementById('cart-note-input');

    if (!checkbox || !container || !input) {
      // Elements might not be available yet, try again after a short delay
      setTimeout(() => this.setupCartNoteListeners(), 100);
      return;
    }

    // Toggle cart note container visibility
    checkbox.addEventListener('change', (e) => {
      if (e.target.checked) {
        container.style.display = 'block';
        input.focus();
      } else {
        container.style.display = 'none';
        input.value = '';
      }
    });
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
        // Setup cart note listeners when notification opens
        this.setupCartNoteListeners();
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.parsedState = parsedState; // Store parsedState for use in other methods
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    
    // Check for Zoi EVOO notification and then open the notification
    this.checkZoiEvooNotification().then(() => {
      // Open the notification after the banner visibility has been determined
      this.open();
    });
  }

  checkZoiEvooNotification() {
    return fetch('/cart.js')
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.json();
    })
    .then(cart => {
      const hasZoiEvoo = cart.items.some(item => 
        item.handle === 'zoi-ultra-high-phenolic-evoo-rich-in-oleocanthal'
      );
      console.log('Has Zoi EVOO:', hasZoiEvoo);
      console.log('Product handles in cart:', cart.items.map(item => item.handle));
      
      var banner = document.querySelector('#cart-notification .notification-banner');
    
      if (hasZoiEvoo) {
        banner.style.display = 'block';
      } else {
        banner.style.display = 'none';
      }
      
      // Return the result so we can chain promises
      return hasZoiEvoo;
    })
    .catch(error => {
      console.error('Could not fetch cart data:', error);
      // Hide banner on error
      var banner = document.querySelector('#cart-notification .notification-banner');
      if (banner) {
        banner.style.display = 'none';
      }
      return false;
    });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
